import { render, staticRenderFns } from "./m-extreme-point.vue?vue&type=template&id=53b9443c&"
import script from "./m-extreme-point.vue?vue&type=script&lang=js&"
export * from "./m-extreme-point.vue?vue&type=script&lang=js&"
import style0 from "./m-extreme-point.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports